<template>
  <div class="l_popup">
    <div class="l_popup__panel animation__popup">
      <div class="l_popup__img">
        <img class="c_img" :src="this.image" />
      </div>
      <div class="l_popup__text">
        <h2 class="c_title">{{this.title}}</h2>
        <div class="l_popup__button">
          <UIButton :label="'もっと見る'" @click="tapDetail" />
        </div>
      </div>
      <div class="l_button__close" @click="tapClose">
        <UICloseButton />
      </div>
    </div>
  </div>
</template>

<script>
import UIButton from '@/components/UIButton'
import UICloseButton from '@/components/UICloseButton'
import { mapActions } from 'vuex'
export default {
  name: 'HomePopup',
  components: {
    UIButton,
    UICloseButton
  },
  props: {
    id: { type: String, required: true },
    title: { type: String, required: true },
    image: { type: String, required: true },
    isPopup: { type: String, required: true }
  },
  computed: {
    ...mapActions('Modal', ['action_toggleModal'])
  },
  created: function () {
    console.log('created')
  },
  methods: {
    tapClose () {
      this.$emit('close')
    },
    tapDetail () {
      this.$emit('navigate')
    }
  }
}
</script>

<style scoped>
.l_popup {
  position: absolute;
  top: 0;
  left: 0;
  display:flex;
  align-items: center;
  justify-content: center;
  width: 100vw;
  height: 100vh;
  background-color: rgba(0, 0, 0, 0.0);
}

.l_popup__panel {
  position: relative;
  border-radius: 6px;
  border: none;
  background-color: #ffffff;
  width: 280px;
}

/* popupアニメーション */
.animation__popup {
  animation: bounce 1s ease normal 0s none running;
}

@keyframes bounce {
  0%, 100%, 20%, 50%, 80% {
      transform: scale(1.0, 1.0);
  }
  40% {
      transform: scale(0.93, 0.93);
  }
  60% {
      transform: scale(0.98, 0.98);
  }
}

.l_popup__img {
  overflow-y: hidden;
  height: 180px;
}

.l_popup__text {
  padding: 15px 10px;
}

.l_popup__button {
  margin: 18px auto 0;
  width: 250px;
}

.c_title {
  font-family: 'HiraKakuPro-W6';
  font-size: 14px;
  font-weight: bold;
  font-style: normal;
  font-stretch: normal;
  line-height: 1.29;
  letter-spacing: normal;
  color: #66160E;
  margin: 10px 10px 0px;
  text-align: left;
  text-overflow: ellipsis;
  display: -webkit-box;
  -webkit-box-orient: vertical;
  -webkit-line-clamp: 3;
  overflow: hidden;
  margin: 0;
  height: 56px;
}

.c_img {
  width: 100%;
  max-width: 100%;
  vertical-align: bottom;
  border-radius: 6px 6px 0 0;
  border: none;
}

/* close button  */
.l_button__close {
  position: absolute;
  top: -15px;
  right: -15px;
  width: 30px;
  height: 30px;
}

</style>
